import { useQuery } from '@tanstack/react-query';
import { fetchPurchaseOrderById } from '@/api/orders';

export const purchaseOrderDetailKeys = {
  detail: (id: string) => ['orders', 'purchases', 'detail', id] as const,
};

export function usePurchaseOrderDetail(id: string) {
  return useQuery({
    queryKey: purchaseOrderDetailKeys.detail(id),
    queryFn: () => fetchPurchaseOrderById(id).then(res => res.data),
    staleTime: 30_000,
    enabled: !!id,
  });
}
